import { parseFile } from '../utils/userAttachments.js';

const savedMode = localStorage.getItem('darkMode');
const isDarkMode =
  savedMode !== null
    ? savedMode === 'true'
    : window.matchMedia('(prefers-color-scheme: dark)').matches;

// Handle file upload from camera or file system
const handleCameraClick = async ({ onFileSelected, isDarkMode: darkMode = isDarkMode }) => {
  // Create a container div for the options
  const optionsContainer = document.createElement('div');
  optionsContainer.className = `fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm`;

  // Create the options modal
  optionsContainer.innerHTML = `
    <div class="${darkMode ? 'bg-[#262626]' : 'bg-white'} rounded-2xl p-6 shadow-xl max-w-sm w-full mx-4" 
         style="box-shadow: ${darkMode ? '0 8px 32px rgba(0, 0, 0, 0.5)' : '0 8px 32px rgba(0, 0, 0, 0.1)'};">
      <h3 class="text-lg font-medium mb-4 ${darkMode ? 'text-white' : 'text-black'}">Attach File</h3>
      <div class="flex flex-col gap-3">
        <button id="capture-btn" class="${darkMode ? 'bg-[#3C3C3C] hover:bg-[#4C4C4C] text-white' : 'bg-gray-50 hover:bg-gray-100 text-black'} px-4 py-3 rounded-xl flex items-center justify-center gap-2 transition-all duration-200"
                style="box-shadow: ${darkMode ? '0 1px 3px rgba(0, 0, 0, 0.3)' : '0 1px 3px rgba(0, 0, 0, 0.1)'};">
          <i class="fas fa-camera"></i>
          Capture Photo
        </button>
        <button id="upload-btn" class="${darkMode ? 'bg-[#3C3C3C] hover:bg-[#4C4C4C] text-white' : 'bg-gray-50 hover:bg-gray-100 text-black'} px-4 py-3 rounded-xl flex items-center justify-center gap-2 transition-all duration-200"
                style="box-shadow: ${darkMode ? '0 1px 3px rgba(0, 0, 0, 0.3)' : '0 1px 3px rgba(0, 0, 0, 0.1)'};">
          <i class="fas fa-upload"></i>
          Upload File
        </button>
        <button id="cancel-btn" class="text-gray-400 hover:text-gray-300 px-4 py-2 rounded-lg mt-2 transition-colors duration-200">
          Cancel
        </button>
        <p class="text-xs text-gray-400 mt-2 text-center">Supported: Images, PDFs, DOCX, TXT</p>
      </div>
    </div>
  `;

  // Add the modal to the document
  document.body.appendChild(optionsContainer);

  // Function to remove the options container
  const removeOptionsContainer = () => {
    if (document.body.contains(optionsContainer)) {
      optionsContainer.style.opacity = '0';
      optionsContainer.style.transition = 'opacity 0.2s ease-out';
      setTimeout(() => {
        if (document.body.contains(optionsContainer)) {
          document.body.removeChild(optionsContainer);
        }
      }, 200);
    }
  };

  // Set initial opacity to 0 and then animate to 1
  optionsContainer.style.opacity = '0';
  setTimeout(() => {
    optionsContainer.style.transition = 'opacity 0.2s ease-in';
    optionsContainer.style.opacity = '1';
  }, 10);

  // Handle capture from camera
  document.getElementById('capture-btn').onclick = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.capture = 'environment'; // This enables the camera

    input.onchange = async (e) => {
      removeOptionsContainer();
      if (e.target.files && e.target.files[0]) {
        try {
          const parsedFile = await parseFile(e.target.files[0]);
          onFileSelected(parsedFile);
        } catch (error) {
          onFileSelected(null, error.message);
        }
      }
    };

    input.click();
  };

  // Handle upload from device
  document.getElementById('upload-btn').onclick = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*,.pdf,.doc,.docx,.txt';

    input.onchange = async (e) => {
      removeOptionsContainer();
      if (e.target.files && e.target.files[0]) {
        try {
          const parsedFile = await parseFile(e.target.files[0]);
          onFileSelected(parsedFile);
        } catch (error) {
          onFileSelected(null, error.message);
        }
      }
    };

    input.click();
  };

  // Handle cancel
  document.getElementById('cancel-btn').onclick = removeOptionsContainer;

  // Add click event to the background to close the modal
  optionsContainer.addEventListener('click', (e) => {
    if (e.target === optionsContainer) {
      removeOptionsContainer();
    }
  });
};

export default handleCameraClick;